import React from 'react';
import { firstError } from '@/utils/errors';
import BackButton from '@/components/buttons/BackButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import TabActions from '@/components/tabs/TabActions';
import { catalogueDiff, validateCatalogueSection } from '../helper';
import DatasetWizardCancelButton from '../../containers/DatasetWizardCancelButton';
import Selectors from '../../hooks/selectors';
import Events from '../../hooks/events';

export const validateFirstSectionStep = ({ dataset, template }) => (
  validateCatalogueSection(catalogueDiff(dataset.catalogue, dataset.copy.catalogue), template, 'first')
);

const FirstCatalogueSectionActions = ({
  category,
  code,
  compact,
  goForward,
}) => {
  const { readErrors, template } = Selectors.useDatasetWizardActionsContainer({ category, code });
  const updateStep = Events.useUpdateActiveDatasetStep(category, { code });
  return (
    <TabActions className="aridhia-dataset-wizard-actions">
      <DatasetWizardCancelButton category={category} code={code} />
      <BackButton onClick={() => updateStep({ step: 0, template })} iconOnly={compact} />
      <ForwardButton disabled={firstError(readErrors)} iconOnly={compact} onClick={goForward} />
    </TabActions>
  );
};

export default FirstCatalogueSectionActions;
